<template>
    <transition name="layout-fade">
        <v-layout wrap column class="layout-add layout-add--max_width">
            <v-toolbar text class="v-toolbar--custom">
                <v-toolbar-title>Глобальные настройки</v-toolbar-title>
                <v-spacer/>
                <v-btn color="info" class="v-btn--save" :loading="loading" :disabled="loading" @click="sendForm">
                    Сохранить
                    <span slot="loader" class="custom-loader">
        				<v-icon light>cached</v-icon>
      				</span>
                </v-btn>
            </v-toolbar>

            <v-form class="form-add">
                <v-flex xs12>
                    <v-layout>
                        <v-flex xs4>
                            <v-subheader class="pa-0">Начисление бонусов за заказ</v-subheader>
                            <v-text-field
                                v-model="settings.bonus_proc"
                                v-validate="'required|between:1,11'"
                                data-vv-name="bonus_proc"
                                :error-messages="errors.collect('bonus_proc')"
                                mask="##"
                                single-line
                                text
                                solo
                                required/>
                        </v-flex>
                    </v-layout>
                </v-flex>

                <v-flex v-if="project.poster_integration" xs12>
                    <v-layout>
                        <v-flex xs4>
                            <v-subheader class="pa-0">Синхронизация с постером</v-subheader>
                            <v-btn color="info" class="v-btn--save" :loading="loading" :disabled="loading"
                                   @click="posterSync">
                                Синхронизировать
                                <span slot="loader" class="custom-loader">
                                    <v-icon light>cached</v-icon>
                                </span>
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-form>
        </v-layout>
    </transition>
</template>

<script>
    import Project from '../../../api/project'

    export default {
        name: 'editSettings',
        $_veeValidate: {
            validator: 'new'
        },

        data: () => ({
            loading: false,
            settings: {
                bonus_proc: 1
            },
            project: null,
            dictionary: {
                custom: {
                    bonus_proc: {
                        required: 'Бонусный кэшбек не введен',
                        between: 'Количество процента должно быть между 1 и 99 %'
                    }
                }
            }
        }),

        mounted () {
            let user = sessionStorage.getItem('user')
            if (user) {
                let userObject = JSON.parse(user)
                if (userObject) {
                    this.project = userObject.data.project
                }
            }

            Project
                .getSettings()
                .then(response => this.settings = response.data.data)
                .catch(error => new Error(error))
        },
        methods: {
            posterSync() {
                this.loading = true
                Project.posterSync()
                    .then(response => {
                        this.$store.commit('showSnackbar', {
                            text: 'Синхронизация завершена',
                            color: 'success'
                        })
                    })
                    .catch(error => {
                        this.$store.commit('showSnackbar', { text: error.response.data.error[Object.keys(error.response.data.error)[0]][0] })
                    })
                    .finally(() => this.loading = false)
            },

            sendForm () {
                this.$validator
                    .validateAll()
                    .then(isValid => {
                        if (!isValid) return

                        this.loading = true

                        Project
                            .editSettings(this.settings)
                            .then(response => {
                                this.settings = response.data.data
                                this.$store.commit('showSnackbar', {
                                    text: 'Настройки сохранены',
                                    color: 'success'
                                })
                                this.$router.push({ path: '/smm' })
                            })
                            .catch(error => {
                                this.$store.commit('showSnackbar', { text: error.response.data.error[Object.keys(error.response.data.error)[0]][0] })
                            })
                            .finally(() => this.loading = false)
                    })
                    .catch(error => new Error(error))
            }
        }
    }
</script>

<style lang="scss">

</style>
